<script>
import CRUDMixins from '../CRUDMixins';
import UiSelect from '@/components/ui/UiSelect.vue';

export default {
    components: { UiSelect },
    mixins: [CRUDMixins],
    props: {
        modelValue: {
            type: [String, Number, Array],
            default: null,
        },
        options: [Array, Object],
        label: String,
        optionValue: {
            type: String,
            default: 'value',
        },
        optionLabel: {
            type: [String, Array],
            default: 'label',
        },
        nullOption: {
            type: Boolean,
            default: false,
        },
        disable: {
            type: Boolean,
            default: false,
        },
        multiple: {
            type: Boolean,
            default: false,
        },
        formData: {
            type: Object,
            default: () => ({}),
        },
        error: {
            type: String,
            default: null,
        },
    },
    computed: {
        labelColumns() {
            return Array.isArray(this.optionLabel) && this.optionLabel.length > 0
                ? this.optionLabel
                : [this.optionLabel];
        },
        uiOptions() {
            const options = this.options || [];
            return options.map((option) => ({
                value: option[this.optionValue],
                label: this.labelColumns.map((col) => String(option[col])).join(' - '),
            }));
        },
        modelProxy: {
            get() {
                if (this.multiple) {
                    if (this.modelValue) {
                        try {
                            return JSON.parse(this.modelValue);
                        } catch (error) {
                            return [];
                        }
                    }
                    return [];
                }
                return this.modelValue;
            },
            set(newValue) {
                if (this.multiple) {
                    this.$emit('update:modelValue', JSON.stringify(newValue));
                } else {
                    this.$emit('update:modelValue', newValue);
                }
            },
        }
    },
    emits: ['update:modelValue'],

};
</script>

<template>
    <UiSelect
        v-model="modelProxy"
        :options="uiOptions"
        :label="label"
        clearable
        :disabled="disable"
        :multiple="multiple"
    />
</template>
